const BRAND_CHOOVIE = "brand_choovie";
const BRAND_TOYOTA = "brand_toyota";
const BRAND_LEXUS = "brand_lexus";
const BRAND_BUDGET_DIRECT = "brand_budget_direct";
const BRAND_AUTO_AND_GENERAL = "brand_auto_and_general";
const BRAND_ORIGIN_ENERGY = "brand_origin_energy";
const BRAND_ROADSHOW_DIRECT = "brand_roadshow_direct";
const BRAND_CINEMA_NEAR_ME = "brand_cinema_near_me";
const BRAND_AIA = "brand_aia";
const BRAND_WBBL = "brand_wbbl";
const PLUS_MOVIES = "brand_plus_movies";

const BRAND_ZENITH = "brand_zenith";

const BRAND_WALT_DISNEY_DEADPOOL_WOLVERINE = "brand_walt_disney_deadpool_wolverine";

const BRAND_BUPA = "brand_bupa";

const BRAND_HOYTS_CINEMABENEFIT = "brand_hoyts_cinemabenefit";

const BRAND_CHOICE_HOTELS = "brand_choice_hotels";

const BRAND_LEXUS_VM = "brand_lexus_vm";

const BRAND_TELSTRA = "brand_telstra";

const BRAND_IGO_DIRECT = "brand_igo_direct";

const BRAND_MAGIC_BEACH = "brand_magic_beach";

const BRAND_TELSTRA_PLUS_MOVIES = "brand_telstra_plus_movies";

const BRAND_ENTERTAINMENT_MOVIES = "brand_entertainment_movies";

const BRAND_BIG_4_PERKS_PLUS_MOVIES = "brand_big_4_perks_plus_movies";

const BRAND_MALTESERS = "brand_maltesers";

const BRAND_CAMP_AUSTRALIA = "brand_camp_australia";

const SITE_CONFIG = [
    {
        "domain": "choovie.com.au",
        "brand_code": "brand_choovie",
        "brand_name": "Choovie",
        "favicon": "asset/img/brands/choovie/choovie-favicon.ico",
        "logo": "asset/img/brands/choovie/logo-choovie.gif",
        "logo_alt_text": "Choovie Logo",
    },
    {
        "domain": "choovie.com.au",
        "brand_code": "brand_wvm",
        "brand_name": "Wholesale Voucher Manager",
        "favicon": "asset/img/brands/wvm/favicon_wvm.png",
        "logo": "asset/img/brands/wvm/logo_wvm.png",
        "logo_alt_text": "Wholesale Voucher Manager Logo",
    },
    {
        "domain": "toyotagomovies.com.au",
        "brand_code": "brand_toyota",
        "brand_name": "Toyota Go",
        "favicon": "asset/img/brands/toyota/favicon-toyota.ico",
        "logo": "asset/img/brands/toyota/logo-toyota.png",
        "logo_alt_text": "Toyota Go Movies Logo",
    },
    {
        "domain": "lexusencoremovies.com.au",
        "brand_code": "brand_lexus",
        "brand_name": "Lexus Encore Movies",
        "favicon": "data:image/svg+xml,%3Csvg width='136' height='31' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24.57 1.4l-.74 1.07c5 1.98 6.99 5.56 6.99 9.41 0 1.93-.54 3.66-1.6 3.66H16.16c-1.76 0-2.3-.6-1.5-2.15 1.42-2.72 5.7-7.92 8.35-11.05.4-.47.7-1.19-.69-1.54-1.42-.36-3.7-.53-5.64-.53C6.84.3 0 5.42 0 12.05c0 6.08 5.93 11.77 16.65 11.77 4.73 0 10.55-1.3 13.82-4.9h-2.82c-3.22 2.81-7.38 3.44-10.97 3.44-8.64 0-14.11-4.34-14.11-10.31 0-5.53 6.18-10.48 14-10.48.93 0 1.25.19.25 1.37-2 2.4-5.56 7.15-7.24 9.93-1.8 2.97.03 5.4 4.08 5.4h16.36c1 0 1.6-.56 2.17-1.57a9.2 9.2 0 001.2-4.65c0-4.49-3.49-8.61-8.82-10.65zm106.71 9.77h-11.1c.38-1.38 1.46-2.31 3.54-2.31h10.6V6.54h-11.28c-6.44 0-7.95 4.4-7.95 6.9h13.74c1.88 0 1.88 2.46.05 2.46h-15.16V6.54h-4.56v9.36h-7.59c-2.02 0-2.88-.94-2.88-2.4V6.54h-7.32l-6.56 4-5.64-4H62.92c-4.7 0-8.04 2.65-8.44 5.97h3.05a7.1 7.1 0 00-2.7 3.42H45.2c-1.82 0-2.65-.91-2.65-2.62V6.54h-4.59v5.75c0 3.66 2.05 5.95 6.73 5.95H76.7l6.59-4 5.64 4.02h6.76l-8.8-6.21 7.18-4.32v6.57c0 2.04 2.73 4 5.21 4h31.99c5.56-.04 5.53-7.13 0-7.13zm-55.4 4.78H60.36c.17-1.26.83-2.5 2.97-2.5h9.63v-2.28H60.12c.23-.94 1.23-2.29 3.54-2.29h10.18V7.62l7.32 5.14-5.27 3.2zM38.23 30.92v-5.2h3.02v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.16v.03zm8.44 0l-1.2-1.76-.23-.36-.25.38-1.2 1.77h-.86l1.86-2.76-1.66-2.44h.91l1.03 1.54c.09.1.17.27.17.27l.17-.27 1.03-1.52h.85l-1.65 2.42 1.88 2.78h-.85v-.05zm4.47-2.07h-1.02v2.04h-.74v-5.17H51c1.08 0 1.77.69 1.77 1.6 0 .82-.74 1.53-1.63 1.53zm-.23-2.47h-.76v1.81h.8c.62 0 1.05-.33 1.05-.93 0-.55-.4-.88-1.09-.88zm3.82 4.54v-5.2h3.03v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.16v.03zm8.5 0l-2.17-2.42v2.42h-.74v-5.2h1.74c1 0 1.65.69 1.65 1.54 0 .82-.74 1.48-1.53 1.48l2 2.18h-.95zm-1.31-4.54h-.88v1.79h.85c.66 0 1.06-.39 1.06-.97 0-.35-.35-.82-1.03-.82zm4.3 4.54v-5.2h.74v5.2h-.74zm3.34 0v-5.2h3.02v.66H70.3v1.65h2.22v.66H70.3v1.54h2.42v.66h-3.16v.03zm9.18 0l-2.82-3.77-.09-.14s.03.11.03.17v3.74h-.74v-5.2h.63l2.79 3.68a.4.4 0 01.08.14l-.02-.16v-3.66h.74v5.2h-.6zm5.19.08a2.67 2.67 0 01-2.65-2.7c0-1.5 1.1-2.7 2.68-2.7.96 0 1.56.34 2 .8l-.55.47a2.02 2.02 0 00-1.43-.57c-1.05 0-1.9.77-1.9 1.98 0 1.34 1.05 2 1.88 2 .5 0 1.1-.19 1.56-.71l.55.44c-.43.55-1.2.99-2.14.99zm4.04-.08v-5.2H91v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.17v.03zm11.23 0l-.65-1.68h-1.7l-.66 1.68h-.77l2.05-5.2h.48l2.08 5.2h-.82zm-1.45-3.83c-.03-.05-.05-.13-.05-.13s-.03.08-.03.13l-.57 1.46h1.2l-.55-1.46zm8.55 3.83v-3.83a.9.9 0 01.03-.19l-.08.11-1.68 2.2h-.29l-1.7-2.14-.1-.11s.03.1.03.19v3.77h-.74v-5.2h.63l2.02 2.53 1.97-2.53h.66v5.2h-.74zm6.28 0l-.66-1.68h-1.7l-.66 1.68h-.77l2.05-5.2h.48l2.08 5.2h-.82zm-1.48-3.83l-.06-.13s-.03.08-.03.13l-.57 1.46h1.2l-.55-1.46zm4.87 3.03l-.09.11h2.85v.69h-4.13l2.82-4.38c.06-.05.12-.13.12-.13h-2.45v-.7h3.76l-2.88 4.41zm4.85.8v-5.2h.74v5.2h-.74zm6.95 0l-2.82-3.77-.09-.14s.03.11.03.17v3.74h-.74v-5.2h.63l2.8 3.68a.4.4 0 01.08.14s-.03-.1-.03-.16v-3.66h.74v5.2h-.6zm5.11.08a2.72 2.72 0 01-2.74-2.7c0-1.6 1.25-2.7 2.74-2.7.88 0 1.45.28 1.99.72l-.46.53a2.31 2.31 0 00-1.53-.53c-1.09 0-1.97.8-1.97 1.98a2 2 0 002 1.98c.76 0 1.39-.4 1.59-1.04h-1.65v-.66h2.48c0 1.4-1.17 2.42-2.46 2.42z' fill='%23fff'/%3E%3C/svg%3E",
        "logo": "data:image/svg+xml,%3Csvg width='136' height='31' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M24.57 1.4l-.74 1.07c5 1.98 6.99 5.56 6.99 9.41 0 1.93-.54 3.66-1.6 3.66H16.16c-1.76 0-2.3-.6-1.5-2.15 1.42-2.72 5.7-7.92 8.35-11.05.4-.47.7-1.19-.69-1.54-1.42-.36-3.7-.53-5.64-.53C6.84.3 0 5.42 0 12.05c0 6.08 5.93 11.77 16.65 11.77 4.73 0 10.55-1.3 13.82-4.9h-2.82c-3.22 2.81-7.38 3.44-10.97 3.44-8.64 0-14.11-4.34-14.11-10.31 0-5.53 6.18-10.48 14-10.48.93 0 1.25.19.25 1.37-2 2.4-5.56 7.15-7.24 9.93-1.8 2.97.03 5.4 4.08 5.4h16.36c1 0 1.6-.56 2.17-1.57a9.2 9.2 0 001.2-4.65c0-4.49-3.49-8.61-8.82-10.65zm106.71 9.77h-11.1c.38-1.38 1.46-2.31 3.54-2.31h10.6V6.54h-11.28c-6.44 0-7.95 4.4-7.95 6.9h13.74c1.88 0 1.88 2.46.05 2.46h-15.16V6.54h-4.56v9.36h-7.59c-2.02 0-2.88-.94-2.88-2.4V6.54h-7.32l-6.56 4-5.64-4H62.92c-4.7 0-8.04 2.65-8.44 5.97h3.05a7.1 7.1 0 00-2.7 3.42H45.2c-1.82 0-2.65-.91-2.65-2.62V6.54h-4.59v5.75c0 3.66 2.05 5.95 6.73 5.95H76.7l6.59-4 5.64 4.02h6.76l-8.8-6.21 7.18-4.32v6.57c0 2.04 2.73 4 5.21 4h31.99c5.56-.04 5.53-7.13 0-7.13zm-55.4 4.78H60.36c.17-1.26.83-2.5 2.97-2.5h9.63v-2.28H60.12c.23-.94 1.23-2.29 3.54-2.29h10.18V7.62l7.32 5.14-5.27 3.2zM38.23 30.92v-5.2h3.02v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.16v.03zm8.44 0l-1.2-1.76-.23-.36-.25.38-1.2 1.77h-.86l1.86-2.76-1.66-2.44h.91l1.03 1.54c.09.1.17.27.17.27l.17-.27 1.03-1.52h.85l-1.65 2.42 1.88 2.78h-.85v-.05zm4.47-2.07h-1.02v2.04h-.74v-5.17H51c1.08 0 1.77.69 1.77 1.6 0 .82-.74 1.53-1.63 1.53zm-.23-2.47h-.76v1.81h.8c.62 0 1.05-.33 1.05-.93 0-.55-.4-.88-1.09-.88zm3.82 4.54v-5.2h3.03v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.16v.03zm8.5 0l-2.17-2.42v2.42h-.74v-5.2h1.74c1 0 1.65.69 1.65 1.54 0 .82-.74 1.48-1.53 1.48l2 2.18h-.95zm-1.31-4.54h-.88v1.79h.85c.66 0 1.06-.39 1.06-.97 0-.35-.35-.82-1.03-.82zm4.3 4.54v-5.2h.74v5.2h-.74zm3.34 0v-5.2h3.02v.66H70.3v1.65h2.22v.66H70.3v1.54h2.42v.66h-3.16v.03zm9.18 0l-2.82-3.77-.09-.14s.03.11.03.17v3.74h-.74v-5.2h.63l2.79 3.68a.4.4 0 01.08.14l-.02-.16v-3.66h.74v5.2h-.6zm5.19.08a2.67 2.67 0 01-2.65-2.7c0-1.5 1.1-2.7 2.68-2.7.96 0 1.56.34 2 .8l-.55.47a2.02 2.02 0 00-1.43-.57c-1.05 0-1.9.77-1.9 1.98 0 1.34 1.05 2 1.88 2 .5 0 1.1-.19 1.56-.71l.55.44c-.43.55-1.2.99-2.14.99zm4.04-.08v-5.2H91v.66h-2.28v1.65h2.22v.66h-2.22v1.54h2.42v.66h-3.17v.03zm11.23 0l-.65-1.68h-1.7l-.66 1.68h-.77l2.05-5.2h.48l2.08 5.2h-.82zm-1.45-3.83c-.03-.05-.05-.13-.05-.13s-.03.08-.03.13l-.57 1.46h1.2l-.55-1.46zm8.55 3.83v-3.83a.9.9 0 01.03-.19l-.08.11-1.68 2.2h-.29l-1.7-2.14-.1-.11s.03.1.03.19v3.77h-.74v-5.2h.63l2.02 2.53 1.97-2.53h.66v5.2h-.74zm6.28 0l-.66-1.68h-1.7l-.66 1.68h-.77l2.05-5.2h.48l2.08 5.2h-.82zm-1.48-3.83l-.06-.13s-.03.08-.03.13l-.57 1.46h1.2l-.55-1.46zm4.87 3.03l-.09.11h2.85v.69h-4.13l2.82-4.38c.06-.05.12-.13.12-.13h-2.45v-.7h3.76l-2.88 4.41zm4.85.8v-5.2h.74v5.2h-.74zm6.95 0l-2.82-3.77-.09-.14s.03.11.03.17v3.74h-.74v-5.2h.63l2.8 3.68a.4.4 0 01.08.14s-.03-.1-.03-.16v-3.66h.74v5.2h-.6zm5.11.08a2.72 2.72 0 01-2.74-2.7c0-1.6 1.25-2.7 2.74-2.7.88 0 1.45.28 1.99.72l-.46.53a2.31 2.31 0 00-1.53-.53c-1.09 0-1.97.8-1.97 1.98a2 2 0 002 1.98c.76 0 1.39-.4 1.59-1.04h-1.65v-.66h2.48c0 1.4-1.17 2.42-2.46 2.42z' fill='%23fff'/%3E%3C/svg%3E",
        "logo_alt_text": "Lexus Encore Movies",
    },
    {
        "domain": "movie-rewards.com.au",
        "brand_code": "brand_movie_rewards",
        "brand_name": "Movie Rewards",
        "favicon": "asset/img/brands/movie-rewards/favicon-movie-rewards.png",
        "logo": "asset/img/brands/movie-rewards/logo-movie-rewards.png",
        "logo_alt_text": "Movie Rewards Logo",
    },
    {
        "domain": "your-brand.choovie.com.au",
        "brand_code": "brand_your",
        "brand_name": "Your Brand",
        "favicon": "asset/img/brands/your/choovie-favicon.ico",
        "logo": "asset/img/brands/your/logo-your-brand.png",
        "logo_alt_text": "Your Brand Movies",
    },
    {
        "domain": "budgetdirectmovies.com.au",
        "brand_code": "brand_budget_direct",
        "brand_name": "Budget Direct",
        "favicon": "asset/img/brands/budget-direct/favicon-budget-direct.ico",
        "logo": "asset/img/brands/budget-direct/logo-budget-direct.jpg",
        "logo_alt_text": "Budget Direct Logo",
    },
    {
        "domain": "www.autogeneralmovies.com.au",
        "brand_code": "brand_auto_and_general",
        "brand_name": "Auto and General",
        "favicon": "asset/img/brands/auto-and-general/auto-and-general.ico",
        "logo": "asset/img/brands/auto-and-general/auto-and-general.png",
        "logo_alt_text": "Auto & General Logo",
    },
    {
        "domain": "www.originmovies.com.au",
        "brand_code": "brand_origin_energy",
        "brand_name": "Origin Movies",
        "favicon": "asset/img/brands/origin-energy/origin-energy.ico",
        "logo": "asset/img/brands/origin-energy/logo-origin-energy.png",
        "logo_alt_text": "Origin Movies Logo",
    },
    {
        "domain": "www.roadshowdirect.com.au",
        "brand_code": "brand_roadshow_direct",
        "brand_name": "Roadshow Direct",
        "favicon": "asset/img/brands/roadshow-direct/favicon-roadshow-direct.ico",
        "logo": "asset/img/brands/roadshow-direct/logo-roadshow-direct.png",
        "logo_alt_text": "Roadshow Direct Logo",
    },
    {
        "domain": "www.cinema-near-me.com.au",
        "brand_code": "brand_cinema_near_me",
        "brand_name": "Cinema Near Me",
        "favicon": "asset/img/brands/cinemanearme/favicon-cinema-near-me.ico",
        "logo": "asset/img/brands/cinemanearme/logo-cinema-near-me.png",
        "logo_alt_text": "Cinema Near Me Logo",
    },
    {
        "domain": "www.aiavitalitycinema.com.au",
        "brand_code": "brand_aia",
        "brand_name": "AIA",
        "favicon": "asset/img/brands/aia/favicon-aia.ico",
        "logo": "asset/img/brands/aia/logo-aia.png",
        "logo_alt_text": "AIA Logo",
    },
    {
        "domain": "wbbl.movie-vouchers.com.au",
        "brand_code": "brand_wbbl",
        "brand_name": "Cricket Victoria",
        "favicon": "asset/img/brands/wbbl/favicon-wbbl.ico",
        "logo": "asset/img/brands/wbbl/logo-wbbl.png",
        "logo_alt_text": "WBBL Logo",
    },
    {
        "domain": "colesplus.movie-vouchers.com.au",
        "brand_code": "brand_coles_plus",
        "brand_name": "Coles Plus",
        "favicon": "asset/img/brands/coles_plus/favicon-coles_plus.png",
        "logo": "asset/img/brands/coles_plus/logo-coles_plus.svg",
        "logo_alt_text": "Coles Plus Logo",
    },
    {
        "domain": "benymovies.movie-vouchers.com.au",
        "brand_code": "brand_beny_movies",
        "brand_name": "Beny",
        "favicon": "asset/img/brands/beny_movies/favicon-beny_movies.png",
        "logo": "asset/img/brands/beny_movies/logo-beny_movies.png",
        "logo_alt_text": "Beny Movies Logo",
    },
    {
        "domain": "sdatas.movie-vouchers.com.au",
        "brand_code": "brand_sda_tas",
        "brand_name": "SDA Tas",
        "favicon": "asset/img/brands/sda_tas/favicon-sda_tas.jpeg",
        "logo": "asset/img/brands/sda_tas/logo-sda_tas.png",
        "logo_alt_text": "SDA Tas Logo",
    },
    {
        "domain": "hawthornfc.movie-vouchers.com.au",
        "brand_code": "brand_hawthorn_fc",
        "brand_name": "Hawthorn Football Club",
        "favicon": "asset/img/brands/hawthorn_fc/favicon-hawthorn_fc.jpg",
        "logo": "asset/img/brands/hawthorn_fc/logo-hawthorn_fc.jpeg",
        "logo_alt_text": "Hawthorn FC Logo",
    },
    {
        "domain": "sisterclubmovies.com.au",
        "brand_code": "brand_sisterclubmovies",
        "brand_name": "Sister Club Movies",
        "favicon": "asset/img/brands/sisterclubmovies/favicon-sisterclubmovies.jpg",
        "logo": "asset/img/brands/sisterclubmovies/logo-sisterclubmovies.png",
        "logo_alt_text": "Sister Club Movies Logo",
    },
    {
        "domain": "cents2bills.movie-vouchers.com.au",
        "brand_code": "brand_cents_bills",
        "brand_name": "Cents 2 Bills",
        "favicon": "asset/img/brands/cents_bills/logo-cents_bills.png",
        "logo": "asset/img/brands/cents_bills/logo-cents_bills.png",
        "logo_alt_text": "Cents 2 Bills Logo",
    },
    {
        "domain": "elevatemovies.movie-vouchers.com.au",
        "brand_code": "brand_pokit_pal",
        "brand_name": "Pokit Pal",
        "favicon": "asset/img/brands/pokit_pal/favicon-pokit-pal.png",
        "logo": "asset/img/brands/pokit_pal/logo-pokit_pal.png",
        "logo_alt_text": "Pokit Pal Logo",

    },
    {
        "domain": "plusmovies.com.au",
        "brand_code": "brand_plus_movies",
        "brand_name": "Plus Movies",
        "favicon": "asset/img/brands/plus-movies/favicon-plus-movies.png",
        "logo": "asset/img/brands/plus-movies/logo-plus-movies.png",
        "logo_alt_text": "Plus Movies Logo",
    },
    {
        "domain": "interiorco.movie-vouchers.com.au",
        "brand_code": "brand_zenith",
        "brand_name": "InteriorCo",
        "favicon": "asset/img/brands/zenith/favicon-zenith.png",
        "logo": "asset/img/brands/zenith/logo-zenith.svg",
        "logo_alt_text": "InteriorCo Logo",

    },
    {
        "domain": "crownrewards.movie-vouchers.com.au",
        "brand_code": "brand_crown",
        "brand_name": "Movie Vouchers",
        "favicon": "asset/img/brands/crown/favicon-crown.png",
        "logo": "asset/img/brands/crown/logo-crown.png",
        "logo_alt_text": "Movie Vouchers Logo",

    },
    {
        "domain": "deadpoolandwolverine.waltdisneycompanyau.com",
        "brand_code": "brand_walt_disney_deadpool_wolverine",
        "brand_name": "Deadpool & Wolverine",
        "favicon": "asset/img/brands/walt_disney_deadpool_wolverine/logo-deadpoolwolverine.png",
        "logo": "asset/img/brands/walt_disney_deadpool_wolverine/logo-deadpoolwolverine.png",
        "logo_alt_text": "Deadpool & Wolverine Logo",

    },
    {
        "domain": "bupa.movie-vouchers.com.au",
        "brand_code": "brand_bupa",
        "brand_name": "Bupa",
        "favicon": "asset/img/brands/bupa/favicon-bupa.png",
        "logo": "asset/img/brands/bupa/logo-bupa.png",
        "logo_alt_text": "Bupa Logo",

    },
    {
        "domain": "hoyts.cinemabenefit.com.au",
        "brand_code": "brand_hoyts_cinemabenefit",
        "brand_name": "Cinema Benefit",
        "favicon": "asset/img/brands/aia/favicon-aia.ico",
        "logo": "asset/img/brands/aia/logo-aia.png",
        "logo_alt_text": "AIA Logo",
    },
    {
        "domain": "choiceprivileges.movie-vouchers.com.au",
        "brand_code": "brand_choice_hotels",
        "brand_name": "Choice Privileges",
        "favicon": "asset/img/brands/choice-hotels/favicon-choice-hotels.png",
        "logo": "asset/img/brands/choice-hotels/logo-choice-hotels.png",
        "logo_alt_text": "Choice Privileges Logo",

    },
    {
        "domain": "lexusencoremovies.movie-vouchers.com.au",
        "brand_code": "brand_lexus_vm",
        "brand_name": "Lexus Encore Movie Vouchers",
        "favicon": "asset/img/brands/lexus/favicon-lexus.ico",
        "logo": "asset/img/brands/lexus/logo-lexus.svg",
        "logo_alt_text": "Lexus Encore Movie Vouchers",
    },
    {
        "domain": "buy.movie-vouchers.com.au",
        "brand_code": "brand_igo_direct",
        "brand_name": "Movie Vouchers",
        "favicon": "asset/img/brands/igo-direct/favicon_igo_direct.png",
        "logo": "asset/img/brands/igo-direct/logo_igo_direct.png",
        "logo_alt_text": "IGO Direct Movie Vouchers",
    },
    {
        "domain": "www.magicbeachmovietix.com.au",
        "brand_code": "brand_magic_beach",
        "brand_name": "Magic Beach Movie Tix",
        "favicon": "asset/img/brands/magic_beach/favicon_magic_beach.jpg",
        "logo": "asset/img/brands/magic_beach/logo_magic_beach.png",
        "logo_alt_text": "Magic Beach Movie Tix Logo",

    },
    {
        "domain": "www.telstraplusmovies.com.au",
        "brand_code": "brand_telstra_plus_movies",
        "brand_name": "Telstra Plus Movies",
        "favicon": "asset/img/brands/telstra-plus-movies/favicon-telstra-plus-movies.png",
        "logo": "asset/img/brands/telstra-plus-movies/logo-telstra-plus-movies.png",
        "logo_alt_text": "Telstra Plus Movies Logo",
    },
    {
        "domain": "entertainmentmovies.movie-vouchers.com.au",
        "brand_code": "brand_entertainment_movies",
        "brand_name": "Movie Vouchers",
        "favicon": "asset/img/brands/entertainment-movies/favicon_entertainment_movies.png",
        "logo": "asset/img/brands/entertainment-movies/logo_entertainment_movies.png",
        "logo_alt_text": "Entertainment Movies Movie Vouchers",
    },
    {
        "domain": "www.big4perksplusmovies.com.au",
        "brand_code": "brand_big_4_perks_plus_movies",
        "brand_name": "big4perksplusmovies",
        "favicon": "asset/img/brands/big_4_perks_plus_movies/favicon_big_4_perks_plus_movies.png",
        "logo": "asset/img/brands/big_4_perks_plus_movies/logo_big_4_perks_plus_movies.png",
        "logo_alt_text": "big4perksplusmovies Logo",

    },
    {
        "domain": "www.maltesersmoviemoments.com.au",
        "brand_code": "brand_maltesers",
        "brand_name": "Maltesers Movie Moments",
        "favicon": "asset/img/brands/maltesers/favicon-maltesers.png",
        "logo": "asset/img/brands/maltesers/logo-maltesers.png",
        "logo_alt_text": "Maltesers Movie Moments Logo",

    },
    {
        "domain": "www.crownstaffclub.movie-vouchers.com.au",
        "brand_code": "brand_crown_staff_club",
        "brand_name": "Crown Staff Club",
        "favicon": "asset/img/brands/crown-staff-club/favicon-crown-staff-club.png",
        "logo": "asset/img/brands/crown-staff-club/logo-crown-staff-club.png",
        "logo_alt_text": "Crown Staff Club Logo",

    },
    {
        "domain": "www.campaustraliamovies.com.au",
        "brand_code": "brand_camp_australia",
        "brand_name": "Camp Australia",
        "favicon": "asset/img/brands/camp_australia/favicon_camp_australia.png",
        "logo": "asset/img/brands/camp_australia/logo_camp_australia.png",
        "logo_alt_text": "Camp Australia Logo",

    },
];

const getSiteConfig = (brandCode) => {
    return SITE_CONFIG.find(item => item.brand_code === brandCode) ?? SITE_CONFIG[0];
};

export {
    BRAND_CHOOVIE,
    BRAND_TOYOTA,
    BRAND_LEXUS,
    BRAND_BUDGET_DIRECT,
    BRAND_AUTO_AND_GENERAL,
    BRAND_ORIGIN_ENERGY,
    BRAND_ROADSHOW_DIRECT,
    BRAND_CINEMA_NEAR_ME,
    BRAND_AIA,
    BRAND_WBBL,
    PLUS_MOVIES,
    BRAND_ZENITH,
    BRAND_WALT_DISNEY_DEADPOOL_WOLVERINE,
    BRAND_BUPA,
    BRAND_HOYTS_CINEMABENEFIT,
    BRAND_CHOICE_HOTELS,
    BRAND_LEXUS_VM,
    BRAND_IGO_DIRECT,
    BRAND_MAGIC_BEACH,
    BRAND_ENTERTAINMENT_MOVIES,
    BRAND_BIG_4_PERKS_PLUS_MOVIES,
    BRAND_MALTESERS,
    BRAND_CAMP_AUSTRALIA,
    getSiteConfig,
};
